import { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import {
  useAddMediaConfig,
  useMediaConfig,
  useUpdateMediaConfig,
} from "./hooks/useMaterial";
import { FaEdit } from "react-icons/fa";
import MediaConfigModalContent from "./ModalContent/MediaConfigModalContent";
import { Spinner } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { showToast } from "../../utils/toastUtils";

type Props = {};
const ImageCell = ({
  mediaId,
  handleViewImage,
}: {
  mediaId?: string;
  handleViewImage?: any;
}) => {
  const [loading, setLoading] = useState(true);

  if (!mediaId) {
    return (
      <div
        style={{
          width: "50px",
          height: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#f0f0f0",
          borderRadius: "4px",
        }}
      >
        No Image
      </div>
    );
  }

  return (
    <div style={{ position: "relative", padding: "5px" }}>
      {loading && (
        <Spinner
          color="success"
          style={{
            color: "green",
            width: "1rem",
            height: "1rem",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}
      <img
        src={`https://tspc-development.truesales.in/media?id=${mediaId}`}
        alt="Image"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "4px",
          display: loading ? "none" : "block",
          cursor: "pointer",
        }}
        onClick={() => handleViewImage(mediaId)}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
      />
    </div>
  );
};

const MediaConfig = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalImageOpen, setIsModalImageOpen] = useState(false);
  const [mediaId, setMediaId] = useState<string | number>("");
  const [modalStatus, setmodalStatus] = useState<string>("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [mediaConfigId, setMediaConfigId] = useState<string | number>("");
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });
  const [formData, setFormData] = useState<string | number | boolean | any>({
    media: "",
    medialabel: "",
    orgunit: "",
    isapp: false,
  });
  const [buttonDisable, setButtonDisable] = useState(false);

  const { data: mediaConfigData, isLoading: mediaConfigDataLoading } =
    useMediaConfig({
      enable: true,
      params: {
        page: filtersState?.page,
        limit: filtersState?.limit,
        search: filtersState?.search,
      },
    });

  const { mutate: addMediaConfig } = useAddMediaConfig();
  const { mutate: updateMediaConfig } = useUpdateMediaConfig();

  const handleClearStates = () => {
    setFormData({
      media: "",
      medialabel: "",
      orgunit: "",
      isapp: false,
    });
    setSelectedRow(null);
    setmodalStatus("");
    setMediaConfigId("");
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    handleClearStates();
    setButtonDisable(false);
  };

  const toggleImageModal = () => {
    setIsModalImageOpen(!isModalImageOpen);
    // handleClearStates();
  };

  const handleEdit = (row: any) => {
    setmodalStatus("Edit");
    setIsModalOpen(!isModalOpen);
    setSelectedRow(row);
    setMediaConfigId(row?.MediaConfigId);
  };

  const handleViewImage = (id: string | number) => {
    setMediaId(id);
    setIsModalImageOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleClose = () => {
    setIsModalOpen(!isModalOpen);
    handleClearStates();
    setButtonDisable(false);
  };

  const handleImageClose = () => {
    setIsModalImageOpen(false);
  };

  const handleSubmit = () => {
    // console.log("FORMDATA:::::::::", formData);
    setButtonDisable(true);
    if (modalStatus === "Edit" && mediaConfigId) {
      if (!formData.medialabel || !formData?.orgunit) {
        setButtonDisable(false);
        showToast.warning("Please Fill the Required Fields !");
        return;
      } else {
        const updateMediaConfigBody = {
          MediaConfigId: mediaConfigId,
          MediaLabel: formData.medialabel,
          Orgunitid: formData?.orgunit,
          IsApp: formData?.isapp,
          MediaId: formData?.media,
        };
        updateMediaConfig(
          { body: updateMediaConfigBody },
          {
            onSuccess: () => {
              handleClose();
            },
            onError: () => {
              console.log("Error in Update!");
            },
          }
        );
      }
    } else {
      if (!formData.medialabel || !formData?.orgunit) {
        setButtonDisable(false);
        showToast.warning("Please Fill the Required Fields !");
        return;
      } else {
        const addMediaConfigBody = {
          MediaLabel: formData.medialabel,
          Orgunitid: formData?.orgunit,
          IsApp: formData?.isapp,
          MediaId: formData?.media,
        };
        addMediaConfig(
          { body: addMediaConfigBody },
          {
            onSuccess: () => {
              handleClose();
            },
            onError: () => {
              console.log("Error in Update!");
            },
          }
        );
      }
    }
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Media Config"
        buttons={[
          {
            label: "+ Add Media Config",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Media Config List"
        data={mediaConfigData?.data?.data || []}
        columns={fileDataColumns(handleEdit, handleViewImage)}
        dynamicHeightOnRowsPerPage={true}
        showSpinner={mediaConfigDataLoading}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={
          mediaConfigData?.data?.pagination?.total_records || 0
        }
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={
          modalStatus === "Edit" ? "Edit Media Config" : "Add Media Config"
        }
        size="md"
        content={
          <MediaConfigModalContent
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            formData={formData}
            setFormData={setFormData}
            modalStatus={modalStatus}
            selectedRow={selectedRow}
            buttonDisable={buttonDisable}
          />
        }
      />

      <RouteModal
        isOpen={isModalImageOpen}
        toggle={toggleImageModal}
        title="View Media"
        size="lg"
        content={
          <div style={{ textAlign: "center" }}>
            {mediaId ? (
              <img
                src={`https://tspc-development.truesales.in/media?id=${mediaId}`}
                alt="Selected"
                style={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  borderRadius: "8px",
                }}
              />
            ) : (
              "No image selected"
            )}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Btn
                style={{
                  backgroundColor: "#43bab2",
                  // backgroundColor: "#F9FAFC",
                  color: "#F9FAFC",
                  border: "1px solid #43bab2",
                  marginTop: "10px",
                  width: "200px",
                }}
                type="button"
                onClick={handleImageClose}
              >
                Close
              </Btn>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default MediaConfig;

const fileDataColumns = (
  handleEdit: (row: any) => void,
  handleViewImage: (row: any) => void
) => [
  {
    name: "Image",
    cell: (row: any) => (
      <ImageCell mediaId={row?.MediaId} handleViewImage={handleViewImage} />
    ),
  },
  {
    name: "Media Label",
    selector: (row: { MediaLabel: string }) => row.MediaLabel || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "BU",
    selector: (row: { BU: string }) => row?.BU || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Is App",
    selector: (row: { IsApp: string }) =>
      row?.IsApp ? ((row?.IsApp).toString() === "true" ? "Yes" : "No") : "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Action",
    cell: (row: any) => (
      <button
        onClick={() => handleEdit(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];
